const state = {
	token: '',
	userInfo: {},
	expires: '',
	menuSort: [],
	menu: [],
	menuCategory: '1',
	appInfo: {}
};
export default state;
